import Technician from '../components/views/technician/Technician.vue'
import TechnicianCreate from '../components/views/technician/TechnicianCreate.vue'
import TechnicianDetails from '../components/views/technician/TechnicianDetails.vue'

const routes = [{
        path: 'operator',
        component: Technician,
        name: 'Technician',
        meta: {
            description: 'List of Think Gas Operators',
            title: 'Operators ',
            requiresAuth: true
        }
    },

    {
        path: '/operator/create',
        component: TechnicianCreate,
        name: 'TechnicianCreate',
        meta: {
            description: 'Add a new Operator',
            title: 'Add Operator',
            requiresAuth: true
        }
    },
    {
        path: '/operator/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'TechnicianCreate' }) : next()
        },
        component: TechnicianDetails,
        name: 'TechnicianDetails',
        meta: {
            description: 'Details for the selected Operator',
            title: 'Update Operator',
            requiresAuth: true
        }
    },
]


export default routes


// WEBPACK FOOTER //
// ./src/routes/technician.route.js